module.exports = __webpack_public_path__ + "img/tu_file_mp4.2140f033.svg";